<template>
    <div class="recent_addedcars">
        <ul>
            <li 
            v-for="(item, index) in opcionesList"
            :key="index"
            class="gray-bg">
                <div class="recent_post_img">
                    <a href="#">
                        <img 
                        src="https://via.placeholder.com/50" 
                        alt="image" />
                    </a>
                </div>
                <div class="recent_post_title">
                    <a 
                    href="#">DATA</a>
                    <p class="widget_price">
                        $ DATA
                    </p>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import mainHelper from 'helpers/main-helper'
export default {
    data() {
        return {
            opcionesList: [
                "",
                "",
                "",
                "",
            ]
        }
    },
    methods: {
        formatPrice(number){
            return mainHelper.numberWithDots(number);
        },
        returnMainImage(data){
            var image_source = '/assets/images/preview.jpg';
            switch (data.fichatecnica.tipo_plan) {
                case 'gratis':
                    image_source = data.fichatecnica.inspeccion_mecanica.fotos[0];
                    break;
                case 'pagada':
                    image_source = data.fichatecnica.inspeccion.fotosvideo.fotos[0];
                    break;
            }
            return image_source;
        },
    },
};
</script>

<style lang="scss" scoped></style>
